import { NextRouter } from 'next/router';

import { routes } from '@/domains/core/routing/routes/routes.default';
import { parseURL } from '@/domains/core/routing/URLParser';
import { PlainQueryParams } from '@/domains/productDiscovery/Listings/interfaces/algolia';
import { TechnicalFiltersOptions } from '@/domains/productDiscovery/Listings/interfaces/filterConfig';
import { ListingPage } from '@/domains/productDiscovery/Listings/model';
import { getMandatoryQueryParamsByPageName } from '@/domains/productDiscovery/Listings/services/route';

export const clearAllFilters = (
  pageName: ListingPage,
  router: NextRouter,
  refine: (
    queryParams: PlainQueryParams,
    clean?: boolean,
    withScrollToTop?: boolean,
    technicalFiltersOptions?: TechnicalFiltersOptions,
  ) => void,
) => {
  const routePattern = routes[pageName];
  const { queryParams } = parseURL(router.asPath, routePattern);

  refine(
    {
      ...getMandatoryQueryParamsByPageName(
        pageName,
        queryParams as PlainQueryParams,
      ),
      sort: queryParams.sort as string,
      inspect_listings: queryParams.inspect_listings as string,
    },
    true,
  );
};
